<app-navbars></app-navbars>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-floating-whatsapp></app-floating-whatsapp>

